import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({
  providedIn: 'root',
})
export class EnvCdssSitService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      isMagellan: '0',
      _env: 'cdss-sit',
      _apiUrl: 'https://sit3-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://sit3-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer:
        'https://cdsssitadb2c.b2clogin.com/d2c9576f-964d-4fb9-963b-992c7803e3fa/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint:
        'https://cdsssitadb2c.b2clogin.com/cdsssitadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl:
        'https://cdsssitadb2c.b2clogin.com/cdsssitadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '0b6d581b-28e1-42f3-9593-0327709ef9ca',
      _scope:
        'openid profile https://cdsssitadb2c.onmicrosoft.com/api/cdss.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl:
        'https://cdsssitadb2c.b2clogin.com/cdsssitadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://sit3-login.p-cis.com/',
      _signInURL:
        'https://cdsssitadb2c.b2clogin.com/cdsssitadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO:
        'https://cdsssitadb2c.b2clogin.com/cdsssitadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl:
        'https://cdsssitadb2c.b2clogin.com/cdsssitadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://cdsssitadb2c.b2clogin.com/cdsssitadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _oktaClientId: '0oah7f9tpi8TyT8Bt4h7',
      _oktaIssuer: 'https://login.4.cares.cwds.ca.gov/oauth2/aush7fkpthAjw29ai4h7',
      _oktaRedirectUri: 'https://sit3-login.p-cis.com/auth/okta/callback',
      _authEndpoint: 'https://cdsssitadb2c.b2clogin.com/cdsssitadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://cdsssitadb2c.b2clogin.com/cdsssitadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9aaf',
      _intercomAppId: 'bqgvwybf'
   
    };
  }
}
